import styled, { css } from 'styled-components';
import theme from '../../../../../styles/defaultTheme';

export const TagContainer = styled.div`
    & div {
        width: fit-content;
    }
`;

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 10px;
    height: 120px;
    background-color: ${(props) => props.color};
    border: 0.8px solid ${() => theme.colorsNormal.lightGreyLink40};
    border-radius: 12px;
    align-items: center; 
    padding: 18px;
    margin-top: 14px;

    strong {
        font: normal normal bold 18px/22px Oxygen;
        letter-spacing: 0px;
        color: #1A171B;
        opacity: 1;
    }
`;

export const ContainerDataContract = styled.div`
    flex-direction: column;
    justify-content: center;
 
    :hover{
        cursor: default;
    }
`;

export const IconPosition = styled.div`
    width: 24px;
    float: left;
`;

export const IconPositionLixeira = styled.div`
    margin-top: 20px;
    cursor: pointer;
`;

export const NameEpecialidadeMedico = styled.div`
    margin-top: 8px;
    max-width: 221px;
    overflow: hidden;
    white-space: normal;
`;

export const styledDivModal = styled.div`
    flex: auto;
    justify-content: space-between;
    flex-direction: column;

    .nomeClinica {
        text-align: left;
        font: normal normal normal 16px/24px Oxygen;
        letter-spacing: 0px;
        color: #5B5B5F;
        opacity: 1;
    }


`;

export const DeleteDrawContainer = styled.div`
    z-index: 1000;
`;

export const ToogleButton = styled.button`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 8px;
    float: right;
    border: 0;
    cursor: pointer;
    font-size: ${theme.font.size16};
    font-weight: bold;
    color: #EC6E0C;
    background-color: transparent;

    svg {
        margin-right: 8px;
    }
`;

export const SectionContainer = styled.div`
    display: flex;
    flex-direction: row;

    @media (max-width: 960px) {
        flex-direction: column;
        align-items: end;
    }
`;

export const Row = styled.div`
    display: flex;
    gap: 24px;

    @media (max-width: 960px) {
        flex-direction: column;
        gap: 0;
        width: 100%;
    }
`;

export const RowButton = styled.div`
    display: flex;
    gap: 24px;
    justify-content: right;

    @media (max-width: 960px) {
        flex-direction: column;
        gap: 0;
        width: 100%;
    }
`;

export const FirstColumn = styled.div`
    margin: 0 24px 0 0;
    width: 100%;

    @media (max-width: 960px) {
        margin: 0;
    }

    ${({ showFilters }) => !showFilters && `display: none;`}
`;

export const GerarCarta = styled.a`
    width: 250px;
    height: 30px;
    margin-left: 40px;
    padding-left: 8px;
    text-align: left;
    text-decoration: underline;
    font: ${theme.font.body[3]};
    color: ${(props) => props.theme.orangeLink};
    display: flex;
    margin-top: 10px;

    span {
        font-size: ${theme.font.size16};
        text-decoration: underline;
        margin-right: 8px;

    }


    &:hover {
        color: ${(props) => props.theme.orangeLink};
        
        ${({ contrastTheme }) =>
            contrastTheme &&
            css`
            text-decoration: underline;
        `}
    }

    &:hover span {
        text-decoration: none;
        color: ${(props) => props.theme.orangeLink};

        ${({ contrastTheme }) =>
            contrastTheme &&
            css`
            text-decoration: underline;
        `}
    }
`;

export const ButtonHospitalArea = styled.div`
    display: flex;
    cursor: pointer;
    button{
        background-color: transparent;
        color: ${() => theme.colorsNormal.orangeLink};
        border: none;
        font-size: ${theme.font.size16};
        text-decoration: underline;
    }

        strong {
        text-align: left;
        text-decoration: underline;
        font: normal normal bold 16px/14px Oxygen;
        letter-spacing: 0px;
        color: #EC6E0C;
        opacity: 1;
        margin-top: 3px;
    }

    button:hover{
        cursor: pointer; 
    }

`;

export const ButtonInfo = styled.button`
    flex-direction: row;
   
`;

export const DivEndItem = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    

`;

export const styleDivCard = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 14px;
`;
